import { useEffect, useState } from 'react';

import LazyLogo from '@/views/AdminDashboard/context/AdmindashboardContext/components/LazyLogo';
import type { TOrgLogoSizeModeProps } from '@/views/AdminDashboard/context/AdmindashboardContext/types';

import useAdminDashboardContext from '../../../hooks/useAdminDashboardContext';

interface LogosStateProps {
  expanded: JSX.Element;
  collapsed: JSX.Element;
}

const mapSizings = (logo: TOrgLogoSizeModeProps, slug: string) => ({
  expanded: <LazyLogo slug={slug} src={logo?.expanded} />,
  collapsed: <LazyLogo slug={slug} src={logo?.collapsed} collapsed />,
});

const useOrgLogo = (slug: string, isDark?: boolean) => {
  const [currentLogo, setCurrentLogo] = useState<LogosStateProps>();
  const { organizationLogo } = useAdminDashboardContext();

  useEffect(() => {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!organizationLogo) return;

    setCurrentLogo(
      isDark
        ? mapSizings(organizationLogo.dark, slug)
        : mapSizings(organizationLogo.light, slug),
    );
  }, [organizationLogo, isDark, slug]);

  return {
    organizationLogo: currentLogo,
  };
};

export default useOrgLogo;
